// extracted by mini-css-extract-plugin
module.exports = {"sellerHeading":"InvoiceSection_sellerHeading__YgQSX"};